import { render, staticRenderFns } from "./choices.vue?vue&type=template&id=acdf268c&"
import script from "./choices.vue?vue&type=script&lang=js&"
export * from "./choices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports